import React from 'react';
import PropTypes from 'prop-types';
import SocialAccount from '../shared/Platform';
import WithImpressions from '../../../WithImpressions';
import './style.scss';

export default function LinkedAccounts({ socialAccounts, biData }) {
    if (!socialAccounts.length) { return null; }

    const seller_card_about_me_linked_accounts = {
        type: 'seller_page.show$viewport',
        seller: {
            id: biData.sellerId
        },
        group: 'seller_card_about_me_linked_accounts_impression',
        page: {
            ctx_id: biData.pageCtxId,
            component: { name: 'seller_card_about_me_linked_accounts' },
            element: {
                position: biData.position,
                type: 'button',
                metadata: 'Linked accounts',
                text: socialAccounts.map((socialAccount) => socialAccount.name).toString(),
                name: 'seller_card_about_me_linked_accounts',
                visible: true
            }
        }
    };

    return (
        <WithImpressions value={seller_card_about_me_linked_accounts} className="linked-accounts">
            <h3>{i18n.t('seller_profile.linked_accounts')}</h3>
            <ul>
                {socialAccounts.map((platform, idx) =>
                    (<SocialAccount key={idx}
                        className="social-account"
                        platformData={{ platform: platform.name }}/>))}
            </ul>
        </WithImpressions>
    );
}

LinkedAccounts.propTypes = {
    socialAccounts: PropTypes.array,
    biData: PropTypes.object
};

LinkedAccounts.defaultProps = {
    socialAccounts: [],
    biData: {}
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/LinkedAccounts/index.js